<template>
  <!-- v-loading="loading" -->
  <div style="min-width:1290px;">
    <MyBanner propPage="myHome" />
    <MyRight />
    <!-- <MyLeft /> -->
    <div class="center-img">
      <!-- <div style="position: relative;margin:0 auto;width:1300px;z-index: 99;display: flex;flex-direction: column;align-items: flex-end;">
        <div><img src="./../static/鹏飞集团白色带英文.png" alt="" style="margin-top:89px;"></div>
        <div style="font-size: 38px;color: rgb(255, 255, 255);text-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);">电子招标投标交易平台</div>
        <div style="font-size: 16px;color: rgb(255, 255, 255);text-shadow: 0px 2px 4px  rgba(0, 0, 0, 0.25);margin-top:59px;">为您提供海量精准的工程项目信息、招标信息、参建单位信息</div>
      </div> -->
    </div>
    <div class="number-block t-20">
      <div class="w70 space-evenly number-box">
        <div class="number-item">
          <div class="img-box"><img src="./../static/通知公告.png.png" alt="" class="img-size"></div>
          <div class="block">
            <div class="text-block">招标项目</div>
            <div class="bands">
              <div class="mynumber-block">{{ numberObj.projectNumber }}</div>
              <div class="mydy-block">个</div>
            </div>
          </div>
        </div>
        <div class="number-item">
          <div class="img-box"><img src="./../static/审阅抄送信息.png.png" alt="" class="img-size"></div>
          <div class="block">
            <div class="text-block">招标金额</div>
            <div class="bands">
              <div class="mynumber-block">{{ Number(numberObj.investmentAmountSum).toFixed(0) }}</div>
              <div class="mydy-block">万元</div>
            </div>
          </div>
        </div>
        <div class="number-item">
          <div class="img-box"><img src="./../static/商品出库.png.png" alt="" class="img-size"></div>
          <div class="block">
            <div class="text-block">专家库</div>
            <div class="bands">
              <div class="mynumber-block">{{ numberObj.expertNumber }}</div>
              <div class="mydy-block">人</div>
            </div>
          </div>
        </div>
        <div class="number-item">
          <div class="img-box"><img src="./../static/资料出库.png.png" alt="" class="img-size"></div>
          <div class="block">
            <div class="text-block">供应商</div>
            <div class="bands">
              <div class="mynumber-block">{{ numberObj.supplierNumber }}</div>
              <div class="mydy-block">个</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="center-block t-30">
      <div class="w70 center-flex">
        <!-- <div>
          <div class="space-between">
            <div style="width: 899px;">
              <div class="center">
                <div class="center-left">
                  <div class="center-title">招采大厅</div>
                  <div class="center-tip">Service announcement</div>
                </div>
              </div>
              <div class="tabs">
                <el-tabs v-model="activeName" type="card" class="demo-tabs" @tab-click="activeScroll" v-loading="loading">
                  <el-tab-pane label="正在公示" name="first">
                    <vue3ScrollSeamless class="scroll-wrap" :classOptions="classOptions" :dataList="EngineeringAnnouncements2">
                      <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements2" :key="index">
                        <div class="tabs-mycontent" :title="item.bulletinName">{{item.bulletinName}}</div>
                        <div class="tabs-time">{{ item.publishTime?item.publishTime.slice(0,11):item.publishTime }}</div>
                      </div>
                    </vue3ScrollSeamless>
                  </el-tab-pane>
                  <el-tab-pane label="正在开标" name="second">
                    <vue3ScrollSeamless class="scroll-wrap" :classOptions="classOptions1" :dataList="xxx">
                      <div class="tabs-content" v-for="(item,index) in EngineeringAnnouncements1" :key="index">
                        <div class="tabs-mycontent">{{item.bulletinName}}</div>
                        <div class="tabs-time">{{ item.openBidTime?item.openBidTime.slice(0,11):item.openBidTime }}</div>
                      </div>
                    </vue3ScrollSeamless>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
          <div class="space-between t-30">
            <div style="width: 899px;">
              <div class="center">
                <div class="center-left">
                  <div class="center-title">招标采购项目</div>
                  <div class="center-tip">Bidding for procurement projects</div>
                </div>
              </div>
              <div class="tabs_370">
                <div class="more-btn ab" @click="goListII">更多 ></div>
                <el-tabs v-model="activeName1" type="card" class="demo-tabs" @tab-click="activeNameIndex" v-loading="loading2">
                  <el-tab-pane :label="item.name" :name="item.value" v-for="(item,lable) in BiddingProcurementProjects" :key="item.value">
                    <div class="tabs-content" v-for="(item,index) in CargoNotice" :key="index" @click="goDetail(item,item.aicId)">
                      <div :class="checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime) == '正在公示'?'tabs-status':'tabs-end'" v-if="lable<3">
                        【{{checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime)}}】
                      </div>
                      <div class="tabs-mycontent" :title="item.bulletinName">{{item.bulletinName}}</div>
                      <div class="tabs-time">{{ item.publishTime.slice(0,11) }}</div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
          <div class="space-between t-30">
            <div style="width: 899px;">
              <div class="center">
                <div class="center-left">
                  <div class="center-title">招募公告</div>
                  <div class="center-tip">Recruitment Announcement</div>
                </div>
              </div>
              <div class="tabs_265">
                <div class="more-btn ab" @click="goRecruitmentAnnouncement">更多 ></div>
                <el-tabs v-model="activeName4" type="card" class="demo-tabs" v-loading="loading5">
                  <el-tab-pane label="招募公告" name='first'>
                    <div class="tabs-content" v-for="item in RecruitmentAnnouncement" :key="item.id" @click="goDetailNew(item,item.aicId)">
                      <div :class="checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime) == '正在公示'?'tabs-status':'tabs-end'">
                        【{{checkRegistrationStatus(item.changeBulletinEndTime,item.bulletinEndTime)}}】
                      </div>
                      <div class="tabs-mycontent" :title="item.bulletinName">{{item.bulletinName}}</div>
                      <div class="tabs-time">{{ item.publishTime.slice(0,11) }}</div>
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </div>
        </div> -->
        <!-- <div class="crnter-r"> -->
        <div class="right-list" style="height: 430px;">
          <div class="box-title space-between">
            <div class="pt-dt pt-dt1">下载中心</div>
            <div class="more-btn" @click="ptdt('下载中心')">更多 ></div>
          </div>
          <div class="box-content" style="padding: 30px 20px;" v-loading="loading4">
            <div class="box-content-item-x" v-for="item in DownloadCenter" :key="item.id"
              @click="goDetailPt(item.id, 2, '下载中心')" :title="item.title">
              <div><img src="./../static/px-downlode.png" alt=""
                  style="width: 17.47px;height: 16.23px;vertical-align: middle;"></div>
              <div class="item-title" style="width:310px;margin-left: 10px;color: black;">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="right-list" style="height: 430px;">
          <div class="box-title space-between">
            <div class="pt-dt pt-dt1">帮助中心</div>
            <div class="more-btn" @click="hc">更多 ></div>
          </div>
          <div class="box-content" style="padding: 30px 20px;" v-loading="loading3">
            <div class="box-content-item-x" v-for="item in HelpCenter" :key="item.id"
              @click="goDetailPt(item.id, 3, '帮助中心')" :title="item.title">
              <div><img src="./../static/what.png" alt=""
                  style="width: 17.47px;height: 16.23px;vertical-align: middle;"></div>
              <div class="item-title" style="width: 310px;margin-left: 10px">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="right-list" style="height: 430px;">
          <div class="box-title" style="display: flex;position: relative;">
            <div class="pt-dt pt-dt1" :class="activeName3 == 'first' ? 'pt-dt1' : ''">登录入口</div>
          </div>
          <div class="box-content">
            <div class="img-text" @click="changeImg(1, '新用户免费注册')">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <div class="hover1 img-ico"></div>
                <div class="text-content">新用户免费注册</div>
              </div>
            </div>
            <div class="img-text" @click="changeImg(2, '用户登录入口')">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <div class="hover2 img-ico"></div>
                <div class="text-content">供应商登录入口</div>
              </div>
            </div>
            <div class="img-text" @click="changeImg(3, '招标人/专家登录入口')">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <div class="hover3 img-ico"></div>
                <div class="text-content">招标人登录入口</div>
              </div>
            </div>
            <div class="img-text" @click="changeImg(3, '招标人/专家登录入口')">
              <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                <div class="hover4 img-ico"></div>
                <div class="text-content">专家登录入口&nbsp;&nbsp;&nbsp;&nbsp;</div>
              </div>
            </div>
            <!-- <a href="https://pfdzztb.pengfeijituan.com/platformDynamicsDetail?ids=1990629336048279553&type=0&title=%E6%93%8D%E4%BD%9C%E6%B5%81%E7%A8%8B" style="text-decoration: none;">
                <div class="img-text">
                  <div style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
                    <div class="hover3 img-ico"></div>
                    <div class="text-content">满意度调查</div>
                  </div>
                </div>
              </a> -->
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>
    <div class="number-block t-20">
      <div class="w70">
        <div class="center">
          <div class="center-left">
            <div class="center-title">友情链接</div>
            <div class="center-tip">Friendship Links</div>
          </div>
        </div>
        <div class="yqlj-box t-20 space-between" style="height: auto;">
          <div class="FriendshipLinks" style="width:19%" v-for="(item, index) in FriendshipLinksArr" :key="item.id"
            @click="changebox(index, item.description)">
            <div @click="activeCloneMes(index)"
              style="width: 100%;height: 100%;display: flex;align-items: center;justify-content: center;">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="outerVisible" width="70%">
      <div class="content">
        <div class="content-tip">
          <div class="bt">{{ mesageData.name }}</div>
          <div class="announcement-flex">
            <div class="flex">
              <div class="title-box">项目类别：</div>
              <div class="content-box">{{ TypeX(mesageData.tradeClassification) }}</div>
            </div>
            <!-- <div class="flex">
                <div class="title-box">报价截止时间：</div>
                <div class="content-box">{{mesageData.endTime}}</div>
              </div> -->
            <div class="flex">
              <div class="title-box">发布时间：</div>
              <div class="content-box">{{ mesageData.publishTime }}</div>
            </div>
          </div>
        </div>
        <!-- <div style="font-size: 14px;color: rgb(10, 96, 234);text-align: left;margin-top: 20px;margin-bottom: 10px;">
            详情介绍：</div> -->
        <div class="content-message" v-html="mesageData.content" v-if="mesageData.content != ''"></div>
      </div>
      <div class="ccl">
        <div class="tip-info">该项目仅限入库供应商查看报名,如需继续查看报名,请登录系统</div>
        <div class="icon">
          <el-icon>
            <ArrowDown />
          </el-icon>
        </div>
        <div class="login-btn" @click="gysLogin()">
          <img src="./../static/供应商.png" alt="" srcset=""> <span>供应商登录入口</span>
        </div>
      </div>
    </el-dialog>
    <MyFooter />
  </div>
</template>
<script setup>
import MyBanner from "@/components/MyBanner.vue";
import MyFooter from "@/components/MyFooter.vue";
import MyRight from "@/components/RightFixd.vue";
import MyLeft from "@/components/LeftFixd.vue";
import { useRouter } from "vue-router";
import { vue3ScrollSeamless } from "vue3-scroll-seamless";
import { findHomeNumber, findTenderBulletinType, listFindTenderBulletin, listFindTenderBulletinBidOpening, listFindTenderBulletinPublishing, listFindRecruitBulletin } from "@/api/PengfeiWebsite/index.js"
import { loginTree, getNoticeById, getAllNav, getNewsTable } from "@/api/index.js"
import { ref, onMounted } from "vue";
let router = useRouter()
let active = ref(1);
let loading = ref(true)
let loading2 = ref(true)
let loading3 = ref(true)
let loading4 = ref(true)
let loading5 = ref(true)
let classOptions = ref({
  step: 0.5,//滚动速度值越大越快，但是值太小会卡顿
  limitMoveNum: 8,//无缝滚动列表元素的长度，一般设置为列表的长度
  direction: 1,//方向: 0 往下 1 往上 2 向左 3 向右。
})
let classOptions1 = ref({
  step: 0.5,
  limitMoveNum: 8,
  direction: 1,
})
let BiddingProcurementProjects = ref()
let activeClone = ref(0);
let activebox = ref(0);
// let loading = ref(true)
let HelpCenter = ref();
let DownloadCenter = ref();
let mesageData = ref({})
let loginTreeArr = ref();
let detailData = async (id) => {
  await getNoticeById({ id: id }).then(res => {
    mesageData.value = res.data
  })
}
let TypeX = (value) => {
  if (value == "A") {
    return '工程'
  } else if (value == "B") {
    return '货物'
  } else if (value == "C") {
    return '服务'
  }
}
let outerVisible = ref(false);
let xxx = ref([]);
let EngineeringAnnouncements1 = ref([]);
let EngineeringAnnouncements2 = ref([]);
let CargoNotice = ref([]);
let RecruitmentAnnouncement = ref([]);
let numberObj = ref({});
let FriendshipLinksArr = ref([])
let changebox = (index, url) => {
  activebox.value = index;
  window.open(url, '_blank')
}
let activeName = ref('first')
let activeName1 = ref(0)
let activeName3 = ref('first')
let activeName4 = ref('first')
let checkRegistrationStatus = (changeBulletinEndTime, bulletinEndTime) => {
  let OneEndTime = new Date(changeBulletinEndTime);
  let endTime = new Date(bulletinEndTime);
  let currentTime = new Date();
  if (changeBulletinEndTime != null && OneEndTime > currentTime) {
    return "正在公示";
  } else if (changeBulletinEndTime != null && OneEndTime < currentTime) {
    return "公示结束";
  } else if (bulletinEndTime != null && endTime > currentTime) {
    return "正在公示";
  } else if (bulletinEndTime != null && endTime < currentTime) {
    return "公示结束";
  }
}
let goListII = () => {
  router.push({ path: "/platformAnnouncements" })
}
let goRecruitmentAnnouncement = () => {
  router.push({ path: "/recruitmentAnnouncement" })
}
let gysLogin = () => {
  window.open('http://27.185.30.230:1501/#/main?jumpSys=3&jumpId=' + mesageData.value.tenderBulletinId, '_blank')
}
let ptdt = (str) => {
  router.push({ path: "/platformDynamics", query: { title: str } })
}
let getDynamicImageUrl = (url) => {
  let currentUrl = window.location.href;
  let parts = currentUrl.split('/');
  let baseUrl = `${parts[0]}//${parts[2]}`;
  return `${baseUrl}` + '/' + `${url}`;
}
let hc = () => {
  router.push({ path: "/helpCenter" })
}
let changeImg = async (id, name) => {
  active.value = id;
  loginTreeArr.value.forEach(item => {
    if (item.dictValue == name) {
      window.open(item.dictKey, '_blank')
    }
  })
}
let activeCloneMes = (index) => {
  activeClone.value = index
}
let goDetail = (item, aicId) => {
  router.push({ path: '/platformAnnouncementsDetail', query: { ids: JSON.stringify(item), aicId: aicId } })
}
let goDetailNew = (item, aicId) => {
  router.push({ path: '/recruitmentAnnouncementDetail', query: { ids: JSON.stringify(item), aicId: aicId } })
}
let goDetailPt = (id, num, str) => {
  router.push({ path: '/platformDynamicsDetail', query: { ids: id, type: num, title: str } })
}
let listFindTenderBulletinMes = async (index) => {
  CargoNotice.value = []
  await listFindTenderBulletin({ bulletinType: index ? index : activeName1.value }).then(res => {
    CargoNotice.value = res.data
    loading2.value = false
  })
}
let listRecruitmentAnnouncementMes = async () => {
  RecruitmentAnnouncement.value = []
  await listFindRecruitBulletin().then(res => {
    RecruitmentAnnouncement.value = res.data
    loading5.value = false
  })
}
let activeNameIndex = async (pane) => {
  await listFindTenderBulletinMes(pane.index)
}
let BeingOpened = async () => {
  await listFindTenderBulletinBidOpening().then(res => {
    EngineeringAnnouncements1.value = res.data
    loading.value = false
  })
}
let BeingAnnounced = async () => {
  await listFindTenderBulletinPublishing().then(res => {
    EngineeringAnnouncements2.value = res.data
  })
}
let activeScroll = (tab) => {
  if (tab.index == 1) {
    xxx.value = EngineeringAnnouncements1.value
  }
}
onMounted(async () => {
  await findHomeNumber().then(res => {
    numberObj.value = res.data
  })
  await BeingOpened()
  await BeingAnnounced()
  await findTenderBulletinType().then(res => {
    BiddingProcurementProjects.value = res
  })
  await listFindTenderBulletinMes()
  await listRecruitmentAnnouncementMes()
  await loginTree().then(res => {
    loginTreeArr.value = res.data
  })
  await getAllNav().then(res => {
    res.data.forEach(item => {
      if (item.categoryName == "下载中心") {
        getNewsTable({ current: 1, size: 6, id: item.id }).then(res => {
          DownloadCenter.value = res.data.records
          loading4.value = false
        })
      } else if (item.categoryName == "帮助中心") {
        getNewsTable({ current: 1, size: 6, id: item.id }).then(res => {
          HelpCenter.value = res.data.records
          loading3.value = false
        })
      } else if (item.categoryName == "友情链接") {
        getNewsTable({ current: 1, size: 5, id: item.id }).then(res => {
          res.data.records = res.data.records.reverse()
          FriendshipLinksArr.value = res.data.records
        })
      }
    })
  })
})
</script>
<style scoped>
.hover1 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/集团用户.png");
  background-size: cover;
}

.hover2 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/supp-green.png");
  background-size: cover;
}

.hover3 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/tender-green.png");
  background-size: cover;
}

.hover4 {
  width: 26px;
  height: 26px;
  margin-right: 15px !important;
  background-image: url("./../static/expert-green.png");
  background-size: cover;
}

.hover3 {
  width: 26px;
  height: 26px;
  margin-left: -20px;
  margin-right: 15px !important;
  background-image: url("./../static/icon3.png");
  background-size: cover;
}

.img-text:hover .hover1 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/集团用户 (1).png") !important;
}

.img-text:hover .hover2 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/supp-white.png") !important;
}

.img-text:hover .hover3 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/tender-white.png") !important;
}

.img-text:hover .hover4 {
  width: 26px;
  height: 26px;
  background-image: url("./../static/expert-white.png") !important;
}

.crnter-r {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.center-block {
  display: flex;
  justify-content: center;
}

.center-flex {
  display: flex;
  justify-content: space-between;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

::v-deep .el-tabs {
  background: rgb(248, 248, 248);
}

::v-deep .el-carousel__indicators--horizontal {
  left: 78%;
  bottom: -2px;
  transform: translateX(0);
}

::v-deep .el-tabs__item.is-active {
  color: #fff;
  background: linear-gradient(180deg,
      rgba(0, 95, 46, 1) 0%,
      rgba(49, 133, 58, 1) 100%);
  position: relative;
}

::v-deep .el-tabs__item.is-active::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translateX(-50%);
  border-top: 8px solid transparent;
  border-bottom: 8px solid #fff;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
}

::v-deep .el-tabs__item {
  width: 139px;
  height: 49px !important;
  font-size: 16px !important;
}

::v-deep .el-tabs--card>.el-tabs__header {
  border-bottom: none;
  height: inherit;
  background: rgb(248, 248, 248);
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__item {
  border-left: none;
}

::v-deep .el-tabs--card>.el-tabs__header .el-tabs__nav {
  border: none;
}

.ab {
  position: absolute;
  top: 15px;
  right: 10px;
  z-index: 999;
}

.w70 {
  width: 1300px;
}

.w56 {
  width: 56%;
  height: 100%;
}

.center {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.center-left {
  display: flex;
  align-items: center;
}

.center-title {
  font-size: 22px;
  font-weight: 700;
  color: #000;
}

.center-tip {
  margin-left: 20px;
  font-size: 18px;
  color: rgb(166, 166, 166);
}

.w44 {
  width: 44%;
  height: 100%;
}

.space-between {
  display: flex;
  justify-content: space-between;
}

.space-evenly {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.number-item {
  display: flex;
}

.bands {
  display: flex;
}

.pa {
  padding: 25px 20px 15px 20px;
  box-sizing: border-box;
}

.t-20 {
  margin-top: 20px;
}

.t-30 {
  margin-top: 30px;
}

.r-20 {
  margin-right: 15px !important;
}

.block {
  margin-left: 16px;
}

.FriendshipLinks {
  width: 220px !important;
  height: 60px;
  border-radius: 4px;
  background: rgba(0, 95, 46, 0.1) !important;
  box-shadow: 0px 6px 12px -2px rgba(50, 50, 93, 0.25),
    0px 3px 7px -3px rgba(0, 0, 0, 0.3) !important;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: rgba(49, 133, 58, 1);
  cursor: pointer;
  text-align: center;
  padding: 5px;
  box-sizing: border-box;
}

.yqlj-box {
  width: 100%;
  padding: 30px;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.right-list {
  width: 413px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.tabs-status {
  font-size: 16px;
  font-weight: 400;
  color: rgba(67, 207, 124, 1);
}

.tabs-end {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 0, 0, 1);
}

.tabs-mycontent {
  width: 77%;
  margin-right: auto;
  font-size: 16px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tabs-time {
  font-size: 14px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}

.img-box {
  width: 82px;
  height: 82px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(0, 95, 46, 1);
  box-shadow: 4px 10px 10px -3px rgba(0, 117, 194, 0.1),
    4px 4px 6px -2px rgba(0, 117, 194, 0.1);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.tabs-content {
  padding: 15px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: all 0.1s;
  color: rgba(0, 0, 0, 1);
  background: #fff;
}

.tabs-content:nth-child(2n) {
  background: rgb(245, 247, 250);
}

.tabs-content:hover {
  color: rgba(0, 117, 194, 1);
  border-left: 4px solid rgba(0, 117, 194, 1);
}

.tabs {
  height: 395px;
  overflow: hidden;
  position: relative;
  margin-top: 27px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.tabs_265 {
  height: 265px;
  overflow: hidden;
  position: relative;
  margin-top: 27px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.tabs_370 {
  height: 370px;
  overflow: hidden;
  position: relative;
  margin-top: 27px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.scroll-wrap {
  width: 100%;
  height: 370px;
  margin: 0 auto;
  overflow: hidden;
}

.img-size {
  width: 45px;
  height: 45px;
}

.text-block {
  font-size: 16px;
  font-weight: 700;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 15px;
}

.mynumber-block {
  font-size: 32px;
  font-weight: 700;
  color: rgba(0, 95, 46, 1);
}

.mydy-block {
  font-size: 12px;
  font-weight: 400;
  line-height: 55px;
  color: rgba(0, 95, 46, 1);
  margin-left: 5px;
}

.number-box {
  padding: 39px 0;
  box-sizing: border-box;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.number-block {
  width: 100%;
  display: flex;
  justify-content: center;
}

.box-content-item {
  height: 24px;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-bottom: 27px;
  cursor: pointer;
}

.box-content-item-x {
  height: 28px;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  position: relative;
  margin-bottom: 24px;
  cursor: pointer;
}

.box-content-item-l {
  height: 28px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  margin-bottom: 18px;
  cursor: pointer;
}

.box-content-item-l::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgba(0, 117, 194, 1);
}

.box-content-item-l:nth-last-child(1) {
  margin-bottom: 0;
}

.box-content-item-x:nth-last-child(1) {
  margin-bottom: 0;
}

.box-content-item:nth-last-child(1) {
  margin-bottom: 0;
}

.box-content-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 40%;
  transform: translateY(-50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: rgb(0, 95, 46);
}

.box-title {
  width: 100%;
  height: 70px;
  border-radius: 4px 4px 0px 0px;
  background: rgba(248, 248, 248, 1);
  padding: 20px 10px 0 20px;
  box-sizing: border-box;
}

.pt-dt {
  font-size: 22px;
  font-weight: 700;
  color: #000;
  position: relative;
  cursor: pointer;
  margin-right: 20px;
}

.pt-dt1::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: rgb(0, 95, 46);
}

.item-title {
  width: 80%;
  font-size: 16px;
  font-weight: 400;
  color: rgb(0, 0, 0);
  margin-left: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.item-time {
  width: 19%;
  text-align: right;
  font-size: 16px;
  font-weight: 400;
  color: rgba(136, 136, 136, 1);
}

.more-btn {
  width: 56px;
  height: 30px;
  border-radius: 4px;
  background: linear-gradient(180deg,
      rgba(246, 193, 101, 1) 0%,
      rgba(224, 168, 50, 1) 100%);
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}

.box-content {
  height: calc(100% - 70px);
  padding: 30px 20px 30px 20px;
  box-sizing: border-box;
}

.carousel-tip {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 35px;
  border-radius: 4px 4px 0px 0px;
  background: rgba(0, 117, 194, 1);
  display: flex;
  align-items: center;
  color: #fff;
  padding: 8px 20px 6px 20px;
  box-sizing: border-box;
}

.carousel-tip-title {
  width: 60%;
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.img-text {
  height: 60px;
  border-radius: 4px;
  background: rgba(0, 95, 46, 0.1);
  box-shadow: 0px 6px 12px -2px rgba(50, 50, 93, 0.25), 0px 3px 7px -3px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  padding: 5px;
  box-sizing: border-box;
  color: rgba(49, 133, 58, 1);
  cursor: pointer;
}

.img-text:nth-last-child(1) {
  margin-bottom: 0;
}

.img-text:hover {
  background: linear-gradient(180deg,
      rgba(0, 95, 46, 1) 0%,
      rgba(49, 133, 58, 1) 100%);
  box-shadow: 0px 6px 12px -2px rgba(0, 117, 194, 0.2),
    0px 3px 7px -3px rgba(0, 117, 194, 0.2);
  color: #fff;
}

.center-img {
  width: 100%;
  height: 450px;
  background-image: url("./../static/1.jpg");
  background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  position: relative;
}

/* .center-img::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(1.5px);
  z-index: 10;
} */
.center-text {
  position: absolute;
  top: 20%;
  left: 22%;
  transform: translateY(-50%);
  color: #fff;
  width: 600px;
  display: flex;
  flex-direction: column;
}

.img-title {
  font-size: 48px;
  font-weight: 400;
  color: #144a89;
}

.img-tip {
  font-size: 48px;
  color: rgba(24, 189, 255, 1);
  margin-top: 10px;
}

.img-content {
  font-size: 16px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin-top: 20px;
}

.img-btn {
  width: 138px;
  height: 44px;
  border-radius: 5px;
  color: #fff;
  text-align: center;
  line-height: 44px;
  border: 1px solid #fff;
  margin-top: 50px;
  cursor: pointer;
}

.PlatformDynamics {
  width: 100%;
  display: flex;
  justify-content: center;
}

.box-left {
  /* width: 69.5%; */
  width: calc(100% - 330px);
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
}

.box-right {
  width: 300px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(233, 237, 242, 1);
  box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  padding: 25px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.active {
  background: linear-gradient(180deg,
      rgba(0, 95, 46, 1) 0%,
      rgba(49, 133, 58, 1) 100%);
  box-shadow: 0px 6px 12px -2px rgba(0, 117, 194, 0.2),
    0px 3px 7px -3px rgba(0, 117, 194, 0.2);
  color: #fff;
}

.activeBorder {
  border-radius: 4px;
}

.activeBorderClone {
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  /* color: #fff; */
}

.FriendshipLinks:hover {
  background: linear-gradient(180deg,
      rgba(0, 95, 46, 1) 0%,
      rgba(49, 133, 58, 1) 100%),
    rgba(235, 244, 250, 1) !important;
  box-shadow: 0px 6px 12px -2px rgba(50, 50, 93, 0.25),
    0px 3px 7px -3px rgba(0, 0, 0, 0.3) !important;
  color: #fff !important;
}

.text-content {
  font-size: 20px;
  font-weight: 400;
}

.img-ico {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}

.img-ico:nth-of-type(2) {
  margin-right: 20px;
}

.l-25 {
  margin-left: 25px;
}

.morebtn-line {
  position: absolute;
  right: 0;
  z-index: 999;
  width: 56px;
  height: 49px;
  font-size: 14px;
  font-weight: 500;
  color: #7d7d7d;
  text-align: center;
  line-height: 49px;
  cursor: pointer;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}

.content {
  border-radius: 4px;
  background: rgba(255, 255, 255, 1);
  padding: 20px;
  margin-bottom: 20px;
  max-height: 230px;
  overflow: hidden;
}

.content-tip {
  border-radius: 5px;
  padding: 20px;
}

.title-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}

.content-box {
  font-size: 14px;
  font-weight: 400;
  color: #bbbbb3 !important;
}

.flex {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.announcement-flex {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}

.bt {
  font-size: 24px;
  font-weight: 600;
  color: #444;
  width: 100%;
  padding-bottom: 10px;
  border-bottom: 1px solid #e4e0e0;
  text-align: center;
}

.login-btn {
  background: #ebf4fa;
  border-radius: 8px;
  width: 50%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(0, 117, 194, 1);
  cursor: pointer;
  margin-top: 10px;
}

.login-btn img {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}

.ccl {
  width: 500px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  position: relative;
}
</style>